import { render, staticRenderFns } from "./placeAnOrder.vue?vue&type=template&id=7276b027&"
import script from "./placeAnOrder.vue?vue&type=script&lang=js&"
export * from "./placeAnOrder.vue?vue&type=script&lang=js&"
import style0 from "./placeAnOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports